import { IMAGES } from "@/lib/config";

// OWNER VERIFICATION REQUIRED: prices imported from the current catering menu board. Confirm before launch.
export const CATERING_PRICES_VERIFIED = false;

export const cateringPackages = [
  {
    key: "quesabirria",
    title: { en: "Quesabirria Taco Boxes", es: "Cajas de Quesabirria" },
    subtitle: { en: "By the box", es: "Por caja" },
    image: IMAGES.quesabirria,
    items: [
      { qty: "50 tacos", price: "$280", consome: "2 × 32 oz consomé" },
      { qty: "100 tacos", price: "$550", consome: "3 × 32 oz consomé" },
      { qty: "150 tacos", price: "$860", consome: "4 × 32 oz consomé" },
      { qty: "200 tacos", price: "$1,150", consome: "5 × 32 oz consomé" },
    ],
  },
  {
    key: "dorados",
    title: { en: "Tacos Dorados Boxes", es: "Cajas de Tacos Dorados" },
    subtitle: { en: "By the box", es: "Por caja" },
    image: IMAGES.tacosDorados,
    items: [
      { qty: "50 tacos", price: "$220", consome: "2 × 32 oz consomé" },
      { qty: "100 tacos", price: "$450", consome: "3 × 32 oz consomé" },
      { qty: "150 tacos", price: "$680", consome: "4 × 32 oz consomé" },
      { qty: "200 tacos", price: "$900", consome: "5 × 32 oz consomé" },
    ],
  },
  {
    key: "birria",
    title: { en: "Birria by the Pound", es: "Birria por Libra" },
    subtitle: { en: "Meat, corn tortillas and consomé — build your own tacos", es: "Carne, tortillas de maíz y consomé — arma tus propios tacos" },
    image: IMAGES.softTacos,
    items: [
      { qty: "5 lbs", price: "$200", consome: "2 × 32 oz consomé" },
      { qty: "10 lbs", price: "$400", consome: "3 × 32 oz consomé" },
      { qty: "15 lbs", price: "$600", consome: "4 × 32 oz consomé" },
      { qty: "20 lbs", price: "$800", consome: "5 × 32 oz consomé" },
    ],
  },
  {
    key: "pizza",
    title: { en: "Birria Pizza Packages", es: "Paquetes de Birria Pizza" },
    subtitle: { en: "14-inch pizzas", es: "Pizzas de 14 pulgadas" },
    image: IMAGES.birriaPizza,
    items: [
      { qty: "4 pizzas", price: "$200", consome: "2 × 32 oz consomé" },
      { qty: "5 pizzas", price: "$240", consome: "3 × 32 oz consomé" },
      { qty: "6 pizzas", price: "$285", consome: "4 × 32 oz consomé" },
    ],
  },
];

export const cateringAddOns = [
  { name: { en: "Full tray of Rice", es: "Charola de arroz" }, price: "$30" },
  { name: { en: "Full tray of Beans", es: "Charola de frijoles" }, price: "$30" },
  { name: { en: "Aguas Frescas", es: "Aguas frescas" }, price: { en: "Ask", es: "Pregunta" } },
  { name: { en: "Mexican Cokes", es: "Coca-Cola mexicana" }, price: { en: "Ask", es: "Pregunta" } },
  { name: { en: "Canned Sodas", es: "Refrescos en lata" }, price: { en: "Ask", es: "Pregunta" } },
];

export const packageOptions = [
  "Quesabirria Taco Box",
  "Tacos Dorados Box",
  "Birria by the Pound",
  "Birria Pizza Package",
  "Mix & Match / Custom",
  "Not sure yet",
];
